import { useLocation, useNavigate } from "react-router-dom";
import { ProgressSpinner } from "primereact/progressspinner";
import { useEffect, useState } from "react";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import StoreMenu from "../StoreMenu";
import { getStoreExternalWarehouseChallanQrcode, removeStoreExternalWarehouseChallanQrcodeById } from "../../services/StoreExternalWarehouse/StoreExternalWarehouse";
import SuccessModal from "../SuccessModal";
import ButtonLink from "../../ButtonLink";

const StoreExternalWarehouseChallanQrcodeData = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const {item} = location.state || {}; 

  const [loading, setLoading] = useState(false);

  const [storeInfoData, setStoreInfoData] = useState([]);

  const [visible, setVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
    const [modalStatus, setModalStatus] = useState(false);
    const [modalText, setModalText] = useState('');

  const [searchTerm, setSearchTerm] = useState("");

  const fetchStoreExternalWarehouseChallanQrcode = id => {
    setLoading(true);
    getStoreExternalWarehouseChallanQrcode(id)
      .then(response => {
        if (!response.data.error) {
          const Res = response.data;
          setStoreInfoData(Res);
          setLoading(false);
        }
      })
      .catch(err => {
        console.error('Error:', err);
      });
  };
 
  useEffect(() => {
    fetchStoreExternalWarehouseChallanQrcode(item.id)
  }, [])
  

  const handleRemoveQrCode = qrCodeId => {    
    removeStoreExternalWarehouseChallanQrcodeById(item.id, qrCodeId)
      .then(response => {
        if (!response.data.error) {
          const Res = response.data;
          if (Res) {
            const message = Res.message;
            const status = Res.status;
          
            if (status === true) {
              setModalVisible(true);
              setModalStatus('success');
              setModalText(message);
              fetchStoreExternalWarehouseChallanQrcode(item.id);
            } else {
              setModalVisible(true);
              setModalStatus('not Success');
              setModalText(message);
            }
          }
        }
      })
      .catch(err => {
        console.error('Error:', err);
      });
  };

  const filterData = (data, searchTerm) => {
    if (!searchTerm) return data; // Return full data if search is empty

    const searchLower = searchTerm.toLowerCase();

    return data.filter((item) =>
      Object.values(item).some((value) =>
        typeof value === "string" || typeof value === "number"
          ? value.toString().toLowerCase().includes(searchLower)
          : false
      )
    );
  };

  const filteredOrderInfoData = filterData(storeInfoData, searchTerm);

   

  const handleClearSearch = () => {
    setSearchTerm("");
  };

  const DeleteTemplate = (rowData) => {
    return (
      <div
        className="px-2 border-round-md cursor-pointer"
        onClick={() =>
            handleRemoveQrCode(rowData.challanQRCodeId)
        }
      >
       <i
        className="pi pi-trash"
        style={{
            fontSize: "20px",
            color: "#1752AA",
        }}
        ></i>
      </div>
    );
  };

  const RenderData = () => {
    return (
      <DataTable
        showGridlines
        value={filteredOrderInfoData}
        // header={header}
        paginator
        rows={10}
        rowsPerPageOptions={[10, 25, 50]}
        tableStyle={{ minWidth: "50rem" }}
        stripedRows
      >
        <Column
          header="S No."
          style={{ width: "80px" }}
          body={(rowData, options) =>
            options.rowIndex + 1}
        ></Column>
        <Column
          field="invoiceNo"
          header="Bill No."
          style={{ width: "100px" }}
          body={(rowData) => rowData?.invoiceNo}
        />
        <Column
          field="garmentName"
          header="Garment Name"
          style={{ width: "200px" }}
        ></Column>
        <Column
          field="serviceName"
          header="Service Name"
          style={{ width: "150px" }}
          body={(rowData) => rowData?.serviceName?.replace(/,/g, ', ')}
        ></Column>
        <Column
          field="Delete"
          header="Delete"
          style={{ width: "120px" }}
          body={DeleteTemplate}
        ></Column>
      </DataTable>
    );
  };
  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/StoreExternalWarehouseChallan")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5 flex justify-content-start align-items-center">
              <p className="text-white text-2xl font-bold uppercase">
                External Warehouse Challan Tags
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>
      <div className="  mt-3">
        <div className="my-2 mx-5 flex flex-1">
          <div className="flex-1">
            <IconField iconPosition="left" className="flex flex-1">
              <InputIcon className="pi pi-search text-xl"> </InputIcon>
              <InputText
                placeholder={"Search"}
                value={searchTerm}
                keyboardType={"default"}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="text-xl flex flex-1 py-1 px-5"
                style={{ borderRadius: 30 }}
              />
            </IconField>
          </div>

          {searchTerm && (
            <div
              className="flex justify-content-center align-items-center mx-2 cursor-pointer"
              onClick={handleClearSearch}
            >
              <div>
                <p className="text-3xl font-bold " style={{ color: "red" }}>
                  X
                </p>
              </div>
            </div>
          )}
          <div className="flex justify-content-center align-items-center ml-3">
            <div
              onClick={() => navigate("/StoreExternalWHChallanComponent", {
                state: { item: item }
              })}
              className="flex cursor-pointer ml-2 pr-4"
            >
              <div className="py-2 ">
                <img
                  src={"Laundy_App_Icons_Gifs/Other_Icons/View_Invoice.png"}
                  style={{
                    height: 25,
                    width: 25,
                    filter: "#fff",
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        {loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : filteredOrderInfoData?.length > 0 ? (
          <div className="mx-4 report-table">{RenderData()}</div>
        ) : (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-semi-bold">No Data Found</p>
          </div>
        )}
      </div>
 
      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={modalStatus}
        text={modalText}
      />
      <StoreMenu setVisible={setVisible} visible={visible} />
      <ButtonLink />
    </div>
  );
};

export default StoreExternalWarehouseChallanQrcodeData;
